import axios from 'axios';
import _ from 'lodash';
import { push } from 'connected-react-router';
import { SIGN_UP_FORM_ID, NETWORK } from '../../../framework/App/AppConstants';
import setUrl from '../../../framework/App/SetUrl';
import { SubmissionError, change} from 'redux-form';
import { NEW_CUST_API, PAGE_NAME } from '../../config/GBConstants';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { processSubmissionErrors } from '../../../shared-components/FormElement/FormElementUtils';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { scrollToTop } from '../../../framework/App/SkeletonPage/SkeletonPageActions';

export const handleRedirect = (response) => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};

export const submitNewCustomerApplication = (data, localePrefix) => (dispatch, getState) => {
    const state = getState();
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;
    return axios
        .request({
            url: NEW_CUST_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data
        })
        .then(response => {
            if (_.get(response, 'data.validation.errors.emailNotAvailable')) {
                dispatch(spinnerClose());
                capeLog && capeLog('email not available');
                capeLog && capeLog(`showCaptcha:  ${_.get(response, 'data.validation.showCaptcha')}`);
                dispatch(setServerData({validationErrorModel:  _.get(response, 'data.validation')}));
                dispatch(setServerData({showCaptcha:  _.get(response, 'data.validation.showCaptcha')}));
                dispatch(change(SIGN_UP_FORM_ID, 'password', ''));
                dispatch(change(SIGN_UP_FORM_ID, 'confirmPassword', ''));
            } else if (!_.isEmpty(_.get(response, 'data.validation.errors'))) {
                dispatch(scrollToTop());
                dispatch(spinnerClose());
                dispatch(setServerData({captchaImgUrl: _.get(response, 'data.captchaImgUrl')}));
                dispatch(setServerData({captchaAudioUrl: _.get(response, 'data.captchaAudioUrl')}));
                dispatch(setServerData({validationErrorModel:  _.get(response, 'data.validation')}));
                //reset the captchaInput field value on submission error
                dispatch(change(SIGN_UP_FORM_ID, 'captchaInput', ''));
                dispatch(change(SIGN_UP_FORM_ID, 'password', ''));
                dispatch(change(SIGN_UP_FORM_ID, 'confirmPassword', ''));
                capeLog && capeLog(`submitApplicationApi:gb:response: server validation error: ${JSON.stringify(response.data.validation.errors)}`);
                return Promise.reject(new SubmissionError(processSubmissionErrors(response.data.validation.errors.fieldError, localePrefix), state));
            } else {
                if (handleRedirect(response)) {
                    return;
                }
                dispatch(setServerData({email: _.get(response, 'data.validation.email')}));
                dispatch(push(PAGE_NAME.APPLY_PAGE));
            }
            dispatch(spinnerClose());
        })
        .catch(error => {
            if (error instanceof SubmissionError) {
                return Promise.reject(error);
            }
            capeLog && capeLog('response:error, GB_NewCustomerPageActions,' + (error && error.message));
            if (handleRedirect(error && error.response)) {
                return;
            }

            if (_.get(error, 'response.data.err', false)) {
                dispatch(setServerData({errorModel: _.get(error, 'response.data', {})}));
                dispatch(push(PAGE_NAME.ERROR_PAGE));
                dispatch(spinnerClose());
            } else {
                // should never be here
                capeLog && capeLog('response:error: unexpected error response for New Customer page submit');
                setUrl(window, PAGE_NAME.NEWCUST_PAGE);
            }
        });
};
